import { render, staticRenderFns } from "./TramoRutaIndex.vue?vue&type=template&id=647f6d00"
import script from "./TramoRutaIndex.vue?vue&type=script&lang=js"
export * from "./TramoRutaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports